import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b4c8ee86")

_pushScopeId("data-v-b4c8ee86")
const _hoisted_1 = { class: "ono-commands" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Thumbnail = _resolveComponent("Thumbnail")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.publicMaterials, (item) => {
      return (_openBlock(), _createBlock(_component_Thumbnail, {
        class: "item",
        key: item.id,
        item: _ctx.toItem(item),
        selected: _ctx.selectedItem?.id == item.id,
        onDragstart: ($event: any) => (_ctx.dragstart($event, item)),
        draggable: "true"
      }, null, 8, ["item", "selected", "onDragstart"]))
    }), 128))
  ]))
})